<script setup>
import {ref, onMounted} from 'vue'
import api from '@/services/api'

const props = defineProps({
    item: Object
})

const count = ref(undefined)

// Fetch variables usage count on mount
onMounted(async () => {
    const obj = await api.get('api/ProductOptions/getVariablesUsageCount/' + props.item.id)
    count.value = obj.data.count
})
</script>

<template>
    <span>
        <span>{{ item.title }}</span>
        <span
            v-if="count !== undefined"
            :class="{ 'bg-secondary': !count, 'bg-success': count }"
            class="badge pull-right"
            title="The number of variations using this variable."
        >{{ count }}</span>
    </span>
</template>